<template>

  <m-pay-layout>

    <v-layout justify-center align-top class="mx-2">
      <v-flex grow>

        <m-pay-generic-paging-table
          :headers="headers"
          :queryFunctionName="queries.recurrings.name"
          :csvQueryFunctionName="queries.recurringAsCsv.name"
          :itemStatusClasses="recurringStatusClasses"
          :cellClasses="cellClasses"
        >
          <template slot-scope={item} slot="transactions">
            <router-link
              :to="{ name: 'transactions', query: { f_purchaseId: item.paymentRequestId } }">
              <v-tooltip bottom>
                    <span slot="activator">
                      <v-icon color="secondary">playlist_add_check</v-icon>
                    </span>
                <span>Transactions</span>
              </v-tooltip>
            </router-link>
          </template>
          <template slot-scope={item} slot="merchant">
            <router-link
              :to="{ name: 'merchant', params: { merchantId: item.merchantId } }">
              <v-tooltip bottom>
                    <span slot="activator">
                      <v-icon color="secondary">store</v-icon>
                    </span>
                <span>Merchant</span>
              </v-tooltip>
            </router-link>
          </template>
          <template slot-scope={item} slot="customer">
            <router-link
              :to="{ name: 'customer', params: { customerId: item.customerId } }">
              <v-tooltip bottom>
                    <span slot="activator">
                      <v-icon color="secondary">person</v-icon>
                    </span>
                <span>Customer</span>
              </v-tooltip>
            </router-link>
          </template>

        </m-pay-generic-paging-table>

      </v-flex>
    </v-layout>

  </m-pay-layout>

</template>

<script>

import MPayGenericPagingTable from './MPayGenericPagingTable';
import MPayCopyButton from './MPayCopyButton';
import MPayStatus from './MPayStatus';
import roles from '../utils/user-roles';
import {
  recurringStatusClasses,
} from '../utils/statuses';

export default {
  name: 'MPayRecurrings',

  components: {
    MPayCopyButton,
    MPayGenericPagingTable,
    MPayStatus,
  },

  data: () => ({
    ruleEditorDialog: false,
    headers: [
      { text: '', value: 'transactions', sortable: false, filterable: false },
      { text: '', value: 'merchant', sortable: false, filterable: false, role: roles.READ_ANY_USER },
      { text: '', value: 'customer', sortable: false, filterable: false, role: roles.READ_ANY_USER },
      { text: 'ID', value: 'id', width: 200 },
      { text: 'Merchant Name', value: 'merchantName' },
      { text: 'Total Amount', value: 'totalAmount', align: 'right' },
      { text: 'Currency', value: 'currency' },
      { text: 'Charge count', value: 'count', align: 'right', sortable: false, filterable: false },
      { text: 'Last Charged at', value: 'lastChargedAt', align: 'right', width: 155, sortable: false, filterable: false },
      { text: 'Status', value: 'status' },
      { text: 'Payment Info', value: 'paymentInfo' },
      { text: 'Created', value: 'createdDate', width: 155 },
      { text: 'Expires', value: 'expirationDate', width: 155 },

    ],
    editedIndex: -1,
    editedItem: {
      recurringId: '',
      amount: 0,
      currency: '',
      description: '',
    },
    cellClasses: {
      transactions: 'pl-3 pr-1',
      merchant: 'pl-0 pr-1',
      customer: 'pl-0 pr-1',
    },
    recurringStatusClasses,
  }),

};
</script>



// WEBPACK FOOTER //
// src/components/MPayRecurrings.vue